import pino from 'pino';

/** 개발 모드용: 콘솔 가독성 최적화 */
export const devLogger = pino({
  transport: {
    target: 'pino-pretty', // dev 전용. prod 번들에 포함되지 않도록 Vite가 tree-shaking
    options: {
      colorize: true,
      translateTime: 'SYS:standard',
      ignore: 'pid,hostname',
      singleLine: false,
    },
  },
  level: 'warn',
});
